












































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

import Moment from 'moment';
import { DailyChallenge } from 'frontend/types/daily-challenges';
import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';
import { User } from 'frontend/types';

@Component({
  components: {
    BriocheImageTag,
  },
  computed: {
    ...mapState('globals', ['user']),
  },
})
export default class DailyChallengeCard extends Vue {
  @Prop(Object) private dailyChallenge!: DailyChallenge;

  private user!: User;

  private gotoDailyProblem(slug: string): void {
    this.$router.push({ name: 'daily_problems_problem', params: { slug } });
  }

  private get feedDate(): string {
    return Moment(this.dailyChallenge.date_ts).format('dddd, MMMM D, YYYY');
  }

  private get showDate(): boolean {
    return (
      this.user.is_staff &&
      !this.user.hide_admin_features &&
      this.$parent.$options.name === 'DailyChallengesFeed'
    );
  }

  private get isSeries(): boolean {
    return Number(this.dailyChallenge.series?.total) > 1;
  }
}
